import React, { useState } from 'react'
import { Stack, Button, Divider } from '@mui/material';
import WarehouseInventoryListContainer from './WarehouseInventoryListContainer';
import ProductImportModalContainer from './products/ProductImportModalContainer';
import ProductExportModalContainer from './products/ProductExportModalContainer';
import ProductDisposalModalContainer from './products/ProductDisposalModalContainer';


const InventoryProductsContainer = () => {
    const [type, setType] = useState(null);
    const [open, setOpen] = useState(false);
    const handleOpen = (param) => {
        setType(param);
        setOpen(true);

    };
    const handleClose = () => {
        setOpen(false);
        setType(null);
    };

    return (
        <div>
            <Stack direction="row" justifyContent="flex-end" alignItems="center" spacing={2} sx={{ p: 1 }}>
                <Button variant="contained" color="secondary" onClick={() => handleOpen('import')}>입고</Button>
                <Button variant="contained" color="primary" onClick={() => handleOpen('export')}>출고</Button>
                <Button variant="contained" color="info" onClick={() => handleOpen('disposal')}>폐기</Button>
            </Stack>
            <Divider />
            <WarehouseInventoryListContainer />

            {open && type === 'import' && (<ProductImportModalContainer open={open} handleClose={handleClose} />)}
            {open && type === 'export' && (<ProductExportModalContainer open={open} handleClose={handleClose} />)}
            {open && type === 'disposal' && (<ProductDisposalModalContainer open={open} handleClose={handleClose} />)}
        </div>
    )
}

export default InventoryProductsContainer